import {MessageCircleDashed as MessageCircle} from 'lucide-react'
import { useState } from "react"

function WhatsAppButton() {
  const [hovered, setHovered] = useState(false)

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 z-50 flex items-center gap-2">
      {/* Desktop hover label */}
      {hovered ? (
        <span className="hidden md:block bg-white text-gray-800 text-sm font-medium px-3 py-2 rounded-lg shadow-lg">
          Fale conosco
        </span>
      ) : null}

      <a
        href="https://wa.me/5527998797619?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20o%20EW%20Pass."
        target="_blank"
        rel="noopener noreferrer"
        className="relative w-14 h-14 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        aria-label="WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <MessageCircle className="w-7 h-7 text-white fill-white" />
        {/* Ping animation */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30" />
      </a>
    </div>
  )
}

export default WhatsAppButton
